export const defaultSiteContent = {
  projects: {
    title: "What I've been building",
    repoUrl: "https://github.com/amandeepsingh29",
    items: [
      {
        name: "PersonalPortfolio",
        description: "A modern portfolio site with animated sections, theme switching, and reusable UI components.",
        lang: "JavaScript",
        url: "https://github.com/amandeepsingh29/PersonalPortfolio",
        image: "https://images.unsplash.com/photo-1512316609839-ce289d3eba0a?q=80&w=1368&auto=format&fit=crop",
        stars: 0,
      },
      {
        name: "Rate Limiter System",
        description: "A practical rate limiting playground exploring token bucket and sliding window strategies.",
        lang: "TypeScript",
        url: "https://github.com/amandeepsingh29",
        image: "https://images.unsplash.com/photo-1628749528992-f5702133b686?q=80&w=1368&auto=format&fit=crop",
        stars: 0,
      },
      {
        name: "Realtime Chat App",
        description: "Socket-driven chat experience with room support, user presence, and minimal latency messaging.",
        lang: "React",
        url: "https://github.com/amandeepsingh29",
        image: "https://images.unsplash.com/photo-1524267213992-b76e8577d046?q=80&w=1368&auto=format&fit=crop",
        stars: 0,
      },
      {
        name: "Cloud Notes API",
        description: "Backend API for notes, authentication, and document search with clean service boundaries.",
        lang: "Node.js",
        url: "https://github.com/amandeepsingh29",
        image: "https://images.unsplash.com/photo-1556740749-887f6717d7e4?q=80&w=1368&auto=format&fit=crop",
        stars: 0,
      },
    ],
  },
  blogPosts: [
    { date: "Jan 23, 2026", title: "The Rate Limiter: System Design Outlook", url: "https://medium.com/@amandeepxsingh/the-rate-limiter-system-design-outlook-48e564507459" },
    { date: "Jul 03, 2025", title: "Welcome to the Speed Wars of Wall Street: How High-Frequency Trading is Redefining Finance", url: "https://medium.com/@amandeepxsingh/welcome-to-the-speed-wars-of-wall-street-how-high-frequency-trading-is-redefining-finance-26d55192cbca" },
    { date: "Jul 02, 2025", title: "Hallucination of Hallucination", url: "http://medium.com/@amandeepxsingh/hallucination-of-hallucination-0a60d18eccef" },
    { date: "Jul 01, 2025", title: "Neuralink Summer 2025: When Mind Meets Machine — A Glimpse Into the Future of Human-AI Integration", url: "https://medium.com/@amandeepxsingh/neuralink-summer-2025-when-mind-meets-machine-a-glimpse-into-the-future-of-human-ai-8e6efd288d5e" },
    { date: "Jan 21, 2025", title: "Understanding Hilbert Space: A Window into Quantum Mechanics and Beyond", url: "https://medium.com/@amandeepxsingh/understanding-hilbert-space-a-window-into-quantum-mechanics-and-beyond-0387215afbcc" },
    { date: "Jan 18, 2025", title: "From CAM to Grad-CAM: How We Make AI Decisions Less Mysterious", url: "https://medium.com/@amandeepxsingh/from-cam-to-grad-cam-how-we-make-ai-decisions-less-mysterious-a92f0f31cead" },
    { date: "Jun 02, 2024", title: "What exactly is SHA-256? Investigating the Secure Hash Algorithm 256", url: "https://medium.com/@amandeepxsingh/what-exactly-is-sha-256-investigating-the-secure-hash-algorithm-256-6d3d164e6570" },
  ],
  papers: [
    { title: "Attention Is All You Need - Transformer Architecture", url: "https://arxiv.org/pdf/1706.03762" },
    { title: "Scaling PostgreSQL to power 800 million ChatGPT users", url: "https://openai.com/index/scaling-postgresql/" },
  ],
  topics: [
    { title: "Machine Learning & Artificial Intelligence", url: "https://github.com/amandeepsingh29/EngineeringTopics/blob/main/machine-learning-ai.md" },
    { title: "System Design & Scalable Systems", url: "https://github.com/amandeepsingh29/EngineeringTopics/blob/main/system-design-scalable-systems.md" },
    { title: "Cloud & Devops", url: "https://github.com/amandeepsingh29/EngineeringTopics/blob/main/cloud-devops.md" },
    { title: "Data Structures and Algorithms", url: "https://github.com/amandeepsingh29/EngineeringTopics/blob/main/data-structures-algorithms.md" },
  ],
  contact: {
    title: "Let's connect",
    description: "I'm always open to new conversations and opportunities.",
    linkedinUrl: "https://linkedin.com/in/amandeepsinghx",
    buttonLabel: "Connect on LinkedIn",
  },
  footer: {
    tagline: "Learning, building and exploring ideas.",
    socials: [
      { platform: "twitter", href: "https://twitter.com/amandeepxsingh" },
      { platform: "linkedin", href: "https://linkedin.com/in/amandeepsinghx" },
      { platform: "github", href: "https://github.com/amandeepsingh29" },
      { platform: "instagram", href: "https://www.instagram.com/amandeep._.singhh" },
      { platform: "medium", href: "https://medium.com/@amandeepxsingh" },
      { platform: "crumbles", href: "https://crumbles.dev" },
    ],
  },
};
